providerCabinetApp.controller('sidebarCtrl', function($scope, $state, profileService) {
    $scope.isState = (type) => {
        if ($state.includes('tendersList.type', {status: type})) {
            return 'active';
        }
    };
    $scope.user = profileService;
});